import { Box } from "@chakra-ui/react";
import React, { memo } from "react";
import { BalanceDetail } from "../../../../../helper/ledger/aggregateBalanceInLedgers";
import { InfoToolTip } from "../../../../atoms/InfoToolTip";
import { BalanceTableHeaders, BalanceTableRow } from "./BalanceDetails";
import { SectionContainer, SectionTitle } from "./SectionTitle";

export const TransactionBalancesSection = memo(
  function TransactionBalancesSection({
    balanceDetails,
  }: {
    balanceDetails: BalanceDetail[];
  }): React.ReactElement {
    return (
      <Box w="full">
        <SectionContainer>
          <SectionTitle>Balances</SectionTitle>
          <InfoToolTip
            label="Shows the Data Source Balance after this transaction, and the Portfolio Balance across all data sources."
            wrap
          />
        </SectionContainer>

        <BalanceTableHeaders />

        {balanceDetails.map((balanceDetail, index) => (
          <BalanceTableRow balanceDetail={balanceDetail} key={index} />
        ))}
      </Box>
    );
  },
);
